import type { Logger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";

interface VerifyPasscodePayload {
    partner: Partner;
    callSid: string;
    sessionId: string;
    transactionId: string;
    passcode: string;
}

interface VerifyPasscodeResult {
    deviceDescription: string;
    technologyType: string;
    zipCode: string;
    token: string;
}

export const verifyPasscode = async (
    ssoAccessToken: string,
    payload: VerifyPasscodePayload,
    verifyCustomerToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/verify-passcode`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: verifyCustomerToken },
            timeout: defaultTimeoutInMS,
        });

        const result = await resp.json<VerifyPasscodeResult>();
        return result;
    } catch (error) {
        logger.error({ error }, `Error: Could not verify passcode.`);
        return { deviceDescription: undefined, technologyType: undefined, zipCode: undefined, token: undefined };
    }
};
